import { apiRequest } from "../api";
import apiPaths from "../api/paths";
import {
  ADD_RIDE_REQUEST,
  SET_RIDE_REQUESTS,
  UPDATE_RIDE_REQUEST,
} from "./types";

export const setRideRequests = (data) => ({
  type: SET_RIDE_REQUESTS,
  data: data,
});

export const addRideRequest = (data) => ({
  type: ADD_RIDE_REQUEST,
  data: data,
});

export const updateRideRequest = (data) => ({
  type: UPDATE_RIDE_REQUEST,
  data: data,
});

export const getRideRequests = () => {
  return (dispatch) => {
    return apiRequest({
      path: apiPaths.rides + "/requests",
    }).then((res) => {
      if (!res.error) {
        dispatch(setRideRequests(res.results));
      }
      return res;
    });
  };
};
